import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import { toast } from "sonner";
import { getErrorMessage } from "../util/functions/UniversalFunctions";
import { TimeTableResponse } from "../types/timeTableType";
import {
    LeaveRequest,
  LeaveRequestFilterParams,
  LeaveRequestPage,
  leaveRequestPayload,
  LeaveStatus,
} from "../types/leaveRequestType";

const leaveRequestApis = {
  //post
  createLeaveRequest: async (
    payload: leaveRequestPayload,
  ): Promise<ApiResponse<leaveRequestPayload> | undefined> => {
    try {
      const response = await customFetch.post(
        "/api/v1/leave-requests/request",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error: any) {
      console.error("Error while applying leave:", error);
      toast.error(getErrorMessage(error) || "Failed to create Leave Request");
    }
  },

  getLeaveRequests: async (
    params: LeaveRequestFilterParams,
  ): Promise<ApiResponse<LeaveRequestPage> | undefined> => {
    try {
      const response = await customFetch.get("/api/v1/leave-requests/filter", {
        params,
      });
      return response.data;
    } catch (error: any) {
      toast.error(getErrorMessage(error) || "Failed to fetch Leave Requests");
    }
  },

  updateLeaveStatus: async (
    leaveRequestId: number,
    status: LeaveStatus,
  ): Promise<ApiResponse<LeaveRequest> | undefined> => {
    try {
      const response = await customFetch.get(
        `/api/v1/leave-requests/update-status/${leaveRequestId}`,
        { params: { status } },
      );
      return response.data;
    } catch (error: any) {
      toast.error(getErrorMessage(error) || "Failed to update Leave Status");
    }
  },
};

export default leaveRequestApis;
